import { OpenIMClient } from './openIMClient';

export const imClient = new OpenIMClient();
export { OpenIMClient };
